<template>
  <v-container fluid class="pa-0" style="display: flex; overflow: hidden;">
    <!-- Left panel -->
    <div :style="{ width: leftWidth + 'px', minWidth: '150px', overflow: 'auto' }">
      <slot name="left" />
    </div>

    <!-- Draggable divider -->
    <div
      class="divider"
      @mousedown="startDrag"
    ></div>

    <!-- Right panel -->
    <div style="flex: 1; overflow: auto;">
      <slot name="right" />
    </div>
  </v-container>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const leftWidth = ref(300)
const isDragging = ref(false)
const dragOffset = ref(0)
let animationFrame = null

function startDrag (e) {
  dragOffset.value = e.clientX - leftWidth.value
  isDragging.value = true
  document.body.style.userSelect = 'none'
  document.documentElement.classList.add('resizing')
}

function stopDrag () {
  isDragging.value = false
  document.body.style.userSelect = ''
  document.documentElement.classList.remove('resizing')
  if (animationFrame) {
    cancelAnimationFrame(animationFrame)
    animationFrame = null
  }
}

function onDrag (e) {
  if (!isDragging.value) return
  if (animationFrame) return // already scheduled

  animationFrame = requestAnimationFrame(() => {
    leftWidth.value = Math.max(150, e.clientX - dragOffset.value)
    animationFrame = null
  })
}

onMounted(() => {
  window.addEventListener('mousemove', onDrag)
  window.addEventListener('mouseup', stopDrag)
})
onBeforeUnmount(() => {
  window.removeEventListener('mousemove', onDrag)
  window.removeEventListener('mouseup', stopDrag)
})
</script>

<style scoped>
.divider {
  width: 3px;
  cursor: col-resize;
  background-color: rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s;
}
.divider:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
